export class CustomerIndividualName {
    public customerNameId: number;
    public customerNumberID: number;
    public customerNameTypeId: number;
    public customerIndividualNameSuffixTypeId: number;
    public firstName: string;
    public middleName: string;
    public lastName: string;
    public isVerified: boolean;

    public customerName: string;
    public customerNameType: string;

    public inactivate: boolean;
    public updatedBy: string;
    public updatedDate: any;
}
